import { render, staticRenderFns } from "./SendRequest.vue?vue&type=template&id=2b693a26"
import script from "./SendRequest.vue?vue&type=script&lang=ts"
export * from "./SendRequest.vue?vue&type=script&lang=ts"
import style0 from "./SendRequest.vue?vue&type=style&index=0&id=2b693a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports